import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import {
  FullBleedSection,
  MaxContentSection,
  BackNavArrowCta,
} from "~/components";
import { routes } from "~/constants";

type PreviousRoute =
  | typeof routes.questionHowDidYouHear
  | typeof routes.partnerOnboardingQuestionPhone
  | typeof routes.planSelect
  | typeof routes.planPayment;

interface Props {
  handleClick: () => void;
  previousRoute: PreviousRoute;
}

export const SimpleNav: FC<Props> = ({ previousRoute, handleClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const { type, ...otherState } = state;

  const handleBackClick = () => {
    handleClick();
    navigate(previousRoute, { replace: true, state: otherState });
  };

  return (
    <FullBleedSection bg="th.cream1" w="full">
      <MaxContentSection
        align="center"
        h={{ base: "3.625rem", md: 22 }}
        justify="center"
        maxW="160rem"
        overflow="hidden"
        position="relative"
        w="full"
      >
        <Flex
          align="center"
          justify="flex-start"
          left="1rem"
          position="absolute"
          w="full"
        >
          <BackNavArrowCta handleClick={handleBackClick} />
        </Flex>
      </MaxContentSection>
    </FullBleedSection>
  );
};
